import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { start as singleSpaStart } from 'single-spa';
import { getSingleSpaExtraProviders } from 'single-spa-angular';

if (environment.production) {
  enableProdMode();
}

singleSpaStart();

const appId = 'porcupine-app';

platformBrowserDynamic(getSingleSpaExtraProviders()).bootstrapModule(AppModule)
  .then(module => {
    NgZone.isInAngularZone = () => {
      return (window as any).Zone.current._properties[appId] === true;
    };

    const rootZone = module.injector.get(NgZone);

    rootZone['_inner']._properties[appId] = true;
  })
  .catch(err => console.error(err));
